export default __webpack_public_path__ + "static/media/corpCap.f8af5f65.PNG";